const crudConfig = {
    endpoint: 'criteriapredicates',
    primaryKey: 'predicateId',
    functions: {
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            args: ['predicateId'],
            query: {
                expand: 'CdsListItemDTO'
            }
        },
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['predicateId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds'
            // args: ['codeSystemDoc']
        }
    },
    metadata: {
        endpoint: 'cds/criteriapredicates',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'cds',
                args: [],
                query: {}
            }
        }
    }
};
export default crudConfig;
